import { render, staticRenderFns } from "./RestaurantCategory.vue?vue&type=template&id=bc0aa342"
import script from "./RestaurantCategory.vue?vue&type=script&lang=js"
export * from "./RestaurantCategory.vue?vue&type=script&lang=js"
import style0 from "./RestaurantCategory.vue?vue&type=style&index=0&id=bc0aa342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports